import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
   * {
   body, html, #root  {
    height: 100vh;
    background-color: #F2F2F2;
  }
`
